export default __webpack_public_path__ + "static/media/CV Hugh Winchester final.887f9a70.pdf";